import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Styles from "css/login_css/loading.module.css";
import { login } from "firebase_/firebase_function/firebase_user";
import { useUser } from "util/context/user_context";
import { baseUrl } from "api/baseUrl";
import OnlyConfirmDialog from "components/onlyConfirm_dialog";

function LoadingScreen() {
  const [modalMessage, setModalMessage] = useState("");
  const [onlyConfirmModal, setOnlyConfirmModal] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setUserData } = useUser();

  /// 애플 로그인
  useEffect(() => {
    const fetchData = async () => {
      const sub = searchParams.get("sub");
      if (sub) {
        const getUserData = await login(sub);
        if (getUserData.length === 0) {
          setUserData({});
          sessionStorage.removeItem("userData");
          navigate("/register", { state: { userId: sub } });
          return;
        }

        const user = getUserData[0];

        if (user.deleteDate) {
          // 탈퇴한 유저
          setOnlyConfirmModal(true);
          setModalMessage("탈퇴한 계정입니다.");
          setUserData({});
          sessionStorage.removeItem("userData");
          navigate("/", { replace: true });
          return;
        }

        await setUserData(user);
        sessionStorage.setItem("userData", JSON.stringify(user.id));
        navigate(user.userType === "수리기사" ? "/expertmain" : "/main");
      }
    };
    fetchData();
  }, []);

  /// 네이버 로그인
  useEffect(() => {
    const hash = window.location.hash;
    // console.log("Hash:---------------", hash);
    if (hash.includes("access_token")) {
      const params = new URLSearchParams(hash.replace("#", ""));
      const accessToken = params.get("access_token");

      fetch(`${baseUrl}/post/naver/profile`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ accessToken }),
      })
        .then((res) => res.json())
        .then(async (data) => {
          window.history.replaceState(null, "", window.location.pathname);
          const uid = data.response["id"];
          const getUserData = await login(uid);
          if (getUserData.length === 0) {
            setUserData({});
            sessionStorage.removeItem("userData");
            navigate("/register", { state: { userId: uid }, replace: true });
            return;
          }

          const user = getUserData[0];

          if (user.deleteDate) {
            // 탈퇴한 유저
            setOnlyConfirmModal(true);
            setModalMessage("탈퇴한 계정입니다.");
            setUserData({});
            sessionStorage.removeItem("userData");
            navigate("/", { replace: true });
            return;
          }

          setUserData(user);
          sessionStorage.setItem("userData", JSON.stringify(user.id));
          navigate(user.userType === "수리기사" ? "/expertmain" : "/main", {
            replace: true,
          });
        })
        .catch((err) => console.error("Naver Login Error : ", err));
    }
  }, []);

  return (
    <div className={Styles.container}>
      <OnlyConfirmDialog
        open={onlyConfirmModal}
        onClose={() => setOnlyConfirmModal(false)}
        message={modalMessage}
      />
    </div>
  );
}

export default LoadingScreen;
